import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { NotificationContainer } from "react-notifications";
import { Card, CardBody, CardHeader } from "../../../_metronic/_partials/controls";
import moment from "moment";
import { Button, Accordion, } from "react-bootstrap";
import sorter from "sort-nested-json";
import DataTable from "../../components/DataTable";
import * as columnFormatters from "../../components/column-formatters";

import TournamentSummeryDetails from "./TournamentSummeryDetails";
import { imageUrl } from "../../components/UIHelpers";

const RankSummary = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const columns = [
    {
      dataField: "noIndex",
      text: "Sr No",
      sort: false,
      show: true,
      format: {
        style: {
          width: '40px',
          minWidth: '40px',
        },
      },
    },
    {
      dataField: "playerInGameName",
      text: "User Game Name",
      sort: true,
      show: true,
    },
    {
      dataField: "playerName",
      text: "Player Name",
      sort: true,
      show: true,
    },
    {
      dataField: "phone",
      text: "Mobile",
      sort: true,
      show: true,
    },
    // {
    //     dataField: "R1RankPoint",
    //     text: "ROUND 1 (R1) RANK POINTS",
    //     sort: true,
    //     show: true,
    //     format: {
    //         formatter: columnFormatters.RoundDataColumnFormatter
    //     },
    // },
    
    {
      dataField: "perKill",
      text: "Per Kill",
      sort: true,
      show: true,
    },
    {
      dataField: "kills",
      text: "Total Kill",
      sort: true,
      show: true,
    },

    // {
    //   dataField: "totalKillPoints",
    //   text: "Total Kill Point",
    //   sort: true,
    //   show: true,
    // },

    {
      text: "Extra point",
      sort: false,
      show: true,
    },
    {
      dataField: "totalRankPoints",
      text: "Total Rank Point",
      sort: true,
      show: true,
    },
    {
      dataField: "totalKillsPoints",
      text: "Total Kill Point",
      sort: true,
      show: true,
    },
    {
      dataField: "totalPoints",
      text: "Total Point",
      sort: true,
      show: true,
    },
    {
      dataField: "rank",
      text: "Winning Rank By Points",
      sort: true,
      show: true,
    },
    {
      dataField: "totalAmount",
      text: "Total Amount",
      sort: true,
      show: true,
    },
    {
      dataField: "totalAmount",
      text: "Winning Prize",
      sort: true,
      show: true,
    }
  ];


  const [rows, setRows] = useState([]);
  const [allColumns, setAllColumns] = useState(columns);
  const [sortDirection, setSortDirection] = useState([]);
  const [showSortArrow, setShowSortArrow] = useState([]);
  // const [maxRound, setMaxRound] = useState(0);
  const [finalResult, setFinalResult] = useState([]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );
  const {
    // pointSummaryTournaments,
    tournamentForEdit,
    pointSummaryUserListing
  } = currentState;
  // console.log(pointSummaryUserListing);
  useEffect(() => {
    dispatch(actions.fetchPointSummary(id));
    dispatch(actions.fetchSingle(id))
  }, [id]);


  useEffect(() => {
    if (pointSummaryUserListing.length > 0) {
      // setPointData(pointSummaryUserListing);
      let tempData = []
      pointSummaryUserListing.map((data, index) => {
        tempData.push({
          "_id": data._id,
          "kills": data.kills,
          "rank": data.rank,
          "rankPoint": data.totalRankPoints,
          "extraPoint": 0,
          "finalPoint": data.totalPoints,
          "tempfinalPoint": data.totalPoints
        })
      });
      setFinalResult(tempData);
      // {
      //   "_id": item._id,
      //   "kills": 0,
      //   "rank": 0,
      //   "isHacking": false,
      //   "isProof": false
      // }
      // const maxRound = Math.max(...pointSummaryUserListing.map(el => el.userRoundPoints.length));
      // console.log(maxRound);
      // setMaxRound(maxRound)
      // for (let i = 0; i < maxRound; i++) {
      //   columns.splice(3 + (i + 1), 0, { dataField: '', text: `ROUND ${i + 1} RANK POINTS`, sort: false, show: true });
      // }
      // const tempData = pointSummaryUserListing.map((data) => {
      //   if (data.userRoundPoints.length !== maxRound) {
      //     return data.userRoundPoints.push({ roundTitle: '-', matchTitle: '-', rank: 0, kills: 0, points: 0 })
      //   }
      // });
      // console.log(tempData);
      // setAllColumns(columns);
      // createTableCol()
      // arr.splice(2, 0, "Lene");
    }
  }, [pointSummaryUserListing]);
  const CurrencyIcoon = ({ item }) => {
    return (
      <span className="text-dark-50 font-weight-bold">
        {item.currency && item.currency.img ? (
          <img
            className="currency"
            // src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${item.currency &&
            //   item.currency.img.default}`}
              src={imageUrl(item.currency && item.currency.img.default)}
            alt="currency"
          />
        ) : (
          <span className="text-dark-50 font-weight-bold">₹</span>
        )}
      </span>
    );
  };

  const onClickSortCol = (key) => {
    let show_sort_arrow = showSortArrow;

    Object.keys(show_sort_arrow).forEach(obj_key => {
      if (obj_key === key)
        show_sort_arrow[obj_key] = true;
      else
        show_sort_arrow[obj_key] = false;
    })
    setShowSortArrow(show_sort_arrow);

    // let sort_key = dataFromNestedKeys(key)

    let arrayCopy = [...rows];
    // arrayCopy.sort(compareBy(key, sortDirection[key]));

    if (sortDirection[key] === "asc")
      arrayCopy = sorter.sort(arrayCopy).asc(key);
    else
      arrayCopy = sorter.sort(arrayCopy).desc(key);

    setRows(arrayCopy);
    // this.setState({rows: arrayCopy});

    let sort_direction = sortDirection;
    if (sort_direction[key] === 'asc')
      sort_direction[key] = 'desc';
    else if (sort_direction[key] === 'desc')
      sort_direction[key] = 'asc';
    setSortDirection(sort_direction);
  };

  const createTableCol = () => {
    return (
      allColumns.map((value, i) => {
        if (value?.format?.type !== 'rowCollasible') {
          let style_icon = { color: '#fff' };
          let arrow_direction = 'down';
          let className_cell_value = ''

          if (value?.sort && showSortArrow[value?.dataField])
            style_icon.display = 'inline';
          else
            style_icon.display = 'none';

          if (sortDirection[value?.dataField] === 'asc')
            arrow_direction = 'down';
          else if (sortDirection[value?.dataField] === 'desc')
            arrow_direction = 'up';

          if (value?.dataField === 'image')
            className_cell_value = 'data_table_cell_value_image';
          else
            className_cell_value = 'data_table_cell_value';

          return (
            <th data-field={value?.dataField} data-sort="desc" key={i}
              className="datatable-cell datatable-cell-sort data_table_cell data_table_th"
              onClick={() => { value?.sort === true && onClickSortCol(value?.dataField) }}
              colSpan={1} rowSpan={1} style={value?.format?.thStyle}
            >
              <span className={`${className_cell_value} data_table_th_value`} style={value?.format?.style}>
                {value?.text}
                <i className={`flaticon2-arrow-${arrow_direction} icon-nm ml-1`} style={style_icon}>
                </i>
              </span>
            </th>
          )
        }
      })
    )
  };

  const reloadLocation = () => {
    window.location.reload();
  };
  const onSubmitSummaryRank = () => {
    // console.log(finalResult);
    // return false;
    let playerData = [];
    finalResult.forEach((value) => {
      playerData.push({"_id": value._id, "kills": value.kills, "rank": value.rank, "extraPoint": value.extraPoint, "finalPoint": value.tempfinalPoint, rankPoint: value.rankPoint})
    });
    console.log("playerData",playerData);
    // return false;
    let payload = {
      tournamentId: id,
      contestPlayer: playerData
    }
    // rankSummaryUserListing.forEach((rank, i) => {
    //   payload.contestPlayer.push({
    //     "id": rank.usersJoinedTournamentData._id,
    //     "rank": rank.rank,
    //     "kills": rank.kills,
    //   })
    // });
    // console.log()
    dispatch(actions.updateWinning(payload)).then((sucess) => sucess ? reloadLocation() : null);
  }
  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <TournamentSummeryDetails />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Card className="card_border">
            <NotificationContainer />
            <div className="card-header p-0">
              <div className="my-5 row mx-0 px-4 w-100 d-flex justify-content-between">
                <div className="" style={{ fontSize: '24px', fontWeight: '600' }}>Tournament Users</div>
              </div>
            </div>

            <CardBody className="p-0 w-100">
              {/* <DataTable
                rows={pointSummaryUserListing.length > 0 ? pointSummaryUserListing : []}
                columns={allColumns}
                isCollapsibleTableData={false}
                // collasibleRowData={collasibleRowData}
                isPagination={false}
              /> */}
              <table className="table dataTable datatable-table contest_data_table_table w-100">
                <thead className="datatable-head data_table_head w-100">
                  <tr className="datatable-row" style={{ left: '0px', }}>

                    {createTableCol()}
                  </tr>
                </thead>

                <tbody className="datatable-body data_table_body w-100">
                  {
                    pointSummaryUserListing.length > 0 &&
                    pointSummaryUserListing.map((value, i) => {

                      return (
                        <tr data-row={value?._id} className="datatable-row data_table_tr" key={i}>
                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{i + 1}</span>
                          </td>
                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{value?.userData?.gamerjiName}</span>
                          </td>
                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{value?.playerName}</span>
                          </td>
                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{value?.phone}</span>
                          </td>
                          {/* {
                            value.userRoundPoints.length > 0 &&
                            value.userRoundPoints.map((round, index) => {
                              return <td className="datatable-cell data_table_cell">
                                <span className="data_table_cell_value">Rank: {round.rank}</span><br />
                                <span className="data_table_cell_value">Points: {round.points}</span><br />
                                <span className="data_table_cell_value">Kills: {round.kills}</span>
                              </td>
                            })
                          } */}

                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{value?.perKill}</span>
                          </td>
                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{value?.kills}</span>
                          </td>
                          {tournamentForEdit.status !== 'completed' &&
                            <td className="datatable-cell data_table_cell">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Extra Point"
                                value={finalResult[i]?.extraPoint}
                                name="rank"
                                onChange={(e) => {
                                  let temp = [...finalResult];
                                  temp[i].extraPoint = Number(e.target.value);
                                  if(Math.sign(e.target.value) === -1){
                                    temp[i].tempfinalPoint = (temp[i].finalPoint) - Number(e.target.value.slice(1));
                                  } else {
                                    temp[i].tempfinalPoint = temp[i].finalPoint + Number(e.target.value);
                                  }
                                  setFinalResult([...finalResult]);
                                }}
                              />
                            </td>
                          }
                          {tournamentForEdit.status === 'completed' &&
                            <td className="datatable-cell data_table_cell">
                              <span className="data_table_cell_value">{value?.extraPoint}</span>
                            </td>
                          }
                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{value?.totalRankPoints}</span>
                          </td>
                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{value?.totalKillsPoints}</span>
                          </td>
                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{value?.totalPoints}</span>
                          </td>
                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{value?.rank}</span>
                          </td>
                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{value?.totalAmount}</span>
                          </td>
                          <td className="datatable-cell data_table_cell">
                            <span className="data_table_cell_value">{value?.totalAmount}</span>
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
              {tournamentForEdit.status !== 'completed' &&
                <div className="btn-group btn-group-lg float-right m-5">
                  <button type="submit" className="btn btn-dark float-left" disabled={pointSummaryUserListing.length === 0} onClick={() => onSubmitSummaryRank()}>
                    Submit
                  </button>
                </div>
              }
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}

export default RankSummary;